import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { isMobile, isTablet } from "../../../@css-style";

export const ElGallery = styled.section`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: relative;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  padding: 5em 0;
  background-attachment: fixed; /* KEY for parallax */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  ${String(isMobile)} {
    padding: 2em 0;
  }
  * {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

export const ElGalleryContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 1em;
  padding: 10px;
  align-items: center;
  justify-content: flex-start;
`;

export const ElColumn = styled.div<{ "data-color"?: string }>`
  width: calc(50% - 0.5em);
  flex: none;
  display: flex;
  flex-wrap: wrap;
  text-align: left;

  ${String(isMobile)} {
    /* width: 100% !important; */
    /* height: auto; */
    /* justify-content: center; */
    /* align-items: center; */
    /* flex: none !important; */
  }
`;

export const ElImageBox = styled.div`
  background-color: var(--theme-main-secondary-color);
  border-radius: 25px;
  padding-top: 65%;
  height: 0;
  position: relative;
  width: 100%;

  img {
    max-width: 100%;
    width: 100%;
    height: auto;
    object-fit: cover;
    position: absolute;
    border-radius: 5px;
    left: 0;
    top: 0;
  }
`;

export const elGapGallery = css`
  gap: 20px;
  position: relative !important;
  z-index: 2 !important;
`;

export const elBgWhite = css`
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.18);
  border-radius: 10px;
`;
